// extracted by mini-css-extract-plugin
export default {"header":"Pane_header__xe7V3","paper":"Pane_paper__HZTtb"};